jQuery(document).ready(function ($) {
    $('.news-nav-item-loader').click(function (e) {
        e.preventDefault()

        $('.news-nav-active').removeClass('news-nav-active')
        $(this).addClass('news-nav-active')

        const data = {
            'action': 'blog_change_post_type',
            'post_type': e.currentTarget.dataset.post_type,
            'page': 1
        }

        $.ajax({ // you can also use $.post here
            url: blog_load_more_params.ajaxurl, // AJAX handler
            data: data,
            type: 'POST',
            // beforeSend: function (xhr) {
            //     button.text('Loading...')
            // },
            success: function (data) {
                if (data) {
                    const button = $('#blog_load_more');
                    blog_load_more_params.current_page = 1
                    button.css({ display: "inline-block" });
                    button.text('Show More')

                    $('.article-container').html(data)
                } else {
                }
            },
        })
    })
})
